import {ObjectId} from 'bson';
import {useGetEnrichmentPreviewResult} from '../../../../hooks/api/fieldDefinitionPreview';

export const useEnrichmentPreviewResult = ({
  accountId,
  fieldDefinitionId,
  isDisabled = false,
}: {
  accountId: ObjectId;
  fieldDefinitionId: ObjectId;
  isDisabled?: boolean;
}) => {
  return useGetEnrichmentPreviewResult(
    {
      accountId,
      fieldDefinitionId,
    },

    {
      enabled: !isDisabled,
      retry: true,
    }
  );
};
